/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_CityInputs */

const en_orders_city = /** @type {(inputs: Orders_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

const es_orders_city = /** @type {(inputs: Orders_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciudad`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Orders_CityInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_city = /** @type {((inputs?: Orders_CityInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_CityInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_city(inputs)
	return es_orders_city(inputs)
});